import axios from '@/axios'

const state = {
  event: null,
  myUpcomingEvents: null
}

const getters = {
  event: (state) => state.event,
  myUpcomingEvents: (state) => {
    if (!state.myUpcomingEvents) {
      return []
    } else {
      return state.myUpcomingEvents
        .sort((a, b) => {
          return new Date(b.event.eventdate) - new Date(a.event.eventdate)
        })
        .reverse()
    }
  }
}

const mutations = {
  SET_MY_UPCOMING_EVENTS: (state, myUpcomingEvents) => {
    state.myUpcomingEvents = myUpcomingEvents
  },
  SET_EVENT: (state, event) => {
    state.event = event
  }
}

const actions = {
  getMyUpcomingEvents({commit}) {
    return Promise.all([
      axios.get('/event-entries/user-events'),
      axios.get('/team-members/eventsforuser')
    ])
      .then((responses) => {
        var now = new Date()
        let entries = responses[0].data.filter(
          (entry) => entry.event && new Date(entry.event.eventenddate) > now
        )
        let teammemberentries = responses[1].data.filter(
          (entry) => entry.event && new Date(entry.event.eventenddate) > now
        )
        teammemberentries.forEach((entry) => {
          entry.teammember = true
        })
        entries = entries.concat(teammemberentries)
        commit('SET_MY_UPCOMING_EVENTS', entries)
        return true
      })
      .catch((err) => {
        return err
      })
  },
  getEvent({commit}, id) {
    return axios.get(`/events/${id}`).then((response) => {
      commit('SET_EVENT', response.data)
      return response.data
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
